import type { PrefetchContext, PrefetchedDataProps } from '#src/shared/prefetch';

import { prefetchSearchPageDataFromApi, useSearchPageDataFromApi } from './pageData';

export type SearchPagePrefetchedContext = Readonly<{
	pageData: Parameters<typeof useSearchPageDataFromApi>[0];
}>;

export type SearchPageCombinedState = ReturnType<typeof useSearchPageDataFromApi>;

export function usePageContext(prefetchedData?: SearchPagePrefetchedContext): SearchPageCombinedState {
	return useSearchPageDataFromApi(prefetchedData?.pageData);
}

export async function prefetchPageContext(context: PrefetchContext): Promise<SearchPagePrefetchedContext> {
	const [pageData] = await Promise.all([prefetchSearchPageDataFromApi(context)]);

	return { pageData };
}

export type SearchPagePrefetchedDataProps = PrefetchedDataProps<SearchPagePrefetchedContext>;
